// @codekit-prepend 'functions.js'
// @codekit-prepend 'banner.js'
// @codekit-prepend 'parallax.js'
// @codekit-prepend 'email-subscription.js'
// @codekit-prepend 'interactive.js'

// Initialisation of the Essay, when the DOM is ready
document.addEventListener('DOMContentLoaded', function(){

	// Banner
	window.addEventListener('load', bannerScroll);
	window.addEventListener('scroll', bannerScroll);
	bannerAnalytics();

	// Email Newsletter
	window.addEventListener('load', emailSetup);
	window.addEventListener('scroll', emailForm);

	// Interactives on the page
	interactive();

	// Parallax
	if(window.innerWidth > 1000){
		window.addEventListener('load', parallax);
		window.addEventListener('scroll', parallax);
	}

	// Print button
	const printButton = document.querySelector('a[title="Print"]');
	if (printButton !== null) {
		printButton.style.display = 'block';
		printButton.addEventListener('click', function(){
			window.print();
		}, false);
	}

	// EasterEgg
	const goodbye = document.getElementById('goodbye');
	if (goodbye !== null) {
		goodbye.addEventListener('contextmenu', function() {
			document.location.href = 'https://www.youtube.com/watch?v=Qy9_lfjQopU';
		}, false);
	}

}, false); // end of Essay
